import React from "react";
import {useState, useEffect, useRef, useLayoutEffect} from 'react';
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';

import './App.css';
import './output.css';

import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";

import sharedVariable from "./global_v";

function BasicQRCode(url) {
  return (
    <div>
      {/* 使用 SVG 渲染（推荐） */}
      <QRCodeSVG value={url} size={200} />
 
      {/* 使用 Canvas 渲染 */}
      {/* <QRCodeCanvas value="https://code.ifrontend.net" /> */}
    </div>
  );
} 

const Pay = () => {
  const temp_count = useRef(0);

  const navigate = useNavigate();

  const [changeClass, setChangeClass] = useState(false);
  const [qrcode_url, set_qrcode_url] = useState('');
  const [pay_amount, set_pay_amount] = useState(0);
  
  const [temp_search_params] = useSearchParams();
  const temp_username = temp_search_params.get('username');
  const temp_pay_amount = temp_search_params.get('amount') * 100;
  const temp_recommender = temp_search_params.get('recommender');

  if (temp_count.current === 0){
    set_pay_amount(temp_pay_amount);

    temp_count.current = 1;

    if (sharedVariable.unfinished_payment.qrcode_url === ''){
        var get_payment_qrcode_url = '';

        if (temp_recommender){
            get_payment_qrcode_url = `https://bailanjo.top/api/pay?username=${temp_username}&amount=${temp_pay_amount}&recommender=${temp_recommender}`;
        }
        else{
            get_payment_qrcode_url = `https://bailanjo.top/api/pay?username=${temp_username}&amount=${temp_pay_amount}`;
        }

        var temp_qrcode_url = '';

        fetch(get_payment_qrcode_url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json(); // 或者 response.text() 根据你的需要
        })
        .then(data => {
            var temp_code = data.code;

            if (temp_code !== 500){
            // 处理返回的数据
            var temp_message = JSON.parse(data.message)
            temp_qrcode_url = temp_message.code_url;
            var temp_out_trade_no = data.out_trade_no;
            set_qrcode_url(temp_qrcode_url);   
            set_pay_amount(temp_pay_amount);  

            setTimeout(() => {
                setChangeClass(true);
            }, 100);            
            
            sharedVariable.unfinished_payment = {'qrcode_url':temp_qrcode_url, 'pay_amount':temp_pay_amount, 'out_trade_no':temp_out_trade_no};
            }
            else{
                alert('错误的请求url！')
            }
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        }); 
    }
    else{
        alert('有未完成的订单！')

        set_qrcode_url(sharedVariable.unfinished_payment.qrcode_url);
        set_pay_amount(sharedVariable.unfinished_payment.pay_amount);

        setTimeout(() => {
            setChangeClass(true);
        }, 100);           
    }
  }

  function cancal_payment(){
    if (sharedVariable.out_trade_no !== ''){
        var cancel_order_url = `https://bailanjo.top/api/close_order?out_trade_no=${sharedVariable.unfinished_payment.out_trade_no}`;

        fetch(cancel_order_url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json(); // 或者 response.text() 根据你的需要
        })
        .then(data => {
            var temp_status = data.status;

            if (temp_status === 'succeed'){
                console.log('已成功取消订单')
            }
            else{
                console.log('取消订单失败！')
            }

            alert('已取消订单')
            sharedVariable.unfinished_payment = {'qrcode_url':'', 'pay_amount':0, 'out_trade_no':''};
            navigate('/user');         
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        });   
    }
    else{
        alert('没有可以取消的订单！')
    }     
  }

  function payment_finished(){
    alert('感谢老板下单:D');

    sharedVariable.unfinished_payment = {'qrcode_url':'', 'pay_amount':0, 'out_trade_no':''};
    navigate('/user');
  }

  return(
    <div style={{minHeight:'calc(100lvh - 4rem)', minWidth:'80rem'}} className="z-10 bg-amber-50 w-full grid place-content-center">
      <div style={{transition:'opacity 1s ease'}} className={!changeClass ? "opacity-0" : "opacity-100"}>
        <div style={{whiteSpace:'pre-wrap'}}>
          {
            qrcode_url !== ''
            ?
            <div style={{width:'50rem', height:'40rem'}} className="grid place-content-center">
                <div style={{fontFamily:'Hello Headline, lyt', fontSize:'36px'}} className="text-center">
                    为账号{temp_username}充值{pay_amount / 100}元
                </div>  
                <div style={{marginTop:'1rem', fontFamily:'Hello Headline, lyt', fontSize:'36px'}} className="text-center">
                    请使用微信扫描以下二维码
                </div>
                <div style={{width:'30rem', height:'16rem', marginTop:'2rem'}} className="grid place-content-center">
                    <div className="bg-amber-200">
                        {BasicQRCode(qrcode_url)}
                    </div>                      
                </div>    
                <div style={{width:'30rem', marginTop:'2rem'}} className="flex">
                    <div style={{width:'30rem', marginTop:'2rem'}} className="grid text-center place-content-center">
                        <div onClick={cancal_payment} style={{width:'13rem', height:'4rem', borderRadius:'5rem', fontFamily:'Hello Headline, lyt', fontSize:'36px', cursor:'pointer',transition:'background-color 1s ease'}} className="bg-amber-200 grid text-center place-content-center hover:bg-amber-400 active:bg-amber-600">
                            取消订单
                        </div>                      
                    </div>                         
                    <div style={{width:'30rem', marginTop:'2rem'}} className="grid text-center place-content-center">
                        <div onClick={payment_finished} style={{width:'13rem', height:'4rem', borderRadius:'5rem', fontFamily:'Hello Headline, lyt', fontSize:'36px', cursor:'pointer',transition:'background-color 1s ease'}} className="bg-amber-200 grid text-center place-content-center hover:bg-amber-400 active:bg-amber-600">
                            已完成支付
                        </div>                      
                    </div>                      
                </div>                               
            </div>    
            :
            <div>
            </div>  
          }
        </div>
      </div>      
    </div> 
  )
}

export default Pay;